var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.params.id ? "图片编辑" : "图片添加",
            visible: _vm.showPopup,
            width: "800px",
            "modal-append-to-body": false,
          },
          on: { close: _vm.close },
        },
        [
          _c(
            "el-form",
            {
              ref: "coverFormRef",
              attrs: {
                model: _vm.params,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "图片：", prop: "coverImageUrl" } },
                [
                  _c(
                    "el-upload",
                    {
                      class: [
                        "avatar-uploader",
                        _vm.params.coverImageType ===
                        _vm.getOrientationEnum.vertical
                          ? "vertical"
                          : "horizontal",
                      ],
                      attrs: {
                        action: _vm.actionUrl,
                        "show-file-list": false,
                        "on-success": _vm.handleAvatarSuccess,
                        "before-upload": _vm.beforeAvatarUpload,
                      },
                    },
                    [
                      _vm.params.coverImageUrl
                        ? _c("el-image", {
                            staticClass: "avatar",
                            attrs: {
                              src: _vm.params.coverImageUrl,
                              fit: "scale-down",
                            },
                          })
                        : _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon",
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "图片样式：", prop: "coverImageType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.params.coverImageType,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "coverImageType", $$v)
                        },
                        expression: "params.coverImageType",
                      },
                    },
                    _vm._l(_vm.getOrientationList, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.value, attrs: { label: item.value } },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveCover } },
                [_vm._v("保 存")]
              ),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }